"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollToTop = void 0;
var _react = require("react");
const useScrollToTop = function () {
  let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[class^="Containerstyle__ContainerContent"]';
  let rerenderParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  (0, _react.useEffect)(() => {
    var _document$querySelect;
    if (document && (_document$querySelect = document.querySelector(selector)) !== null && _document$querySelect !== void 0 && _document$querySelect.scrollTo) {
      var _document$querySelect2;
      (_document$querySelect2 = document.querySelector(selector)) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.scrollTo(0, 0);
    }
  }, [...rerenderParams]);
};
exports.useScrollToTop = useScrollToTop;